import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { HomeComponent } from './home';

import { InformationComponent } from './_components/information/information.component';
import { AutomationRequestComponent } from './_components/user/automation-request/automation-request.component';
import { ResetPasswordComponent } from './_components/resetpassword/resetpassword.component';
import { UserValidateComponent } from './_components/user/user-validate/user-validate.component';
import { AuthGuard } from './_helpers';

const accountModule = () => import('./account/account.module').then(x => x.AccountModule);
const connectionModule = () => import('./connection/connection.module').then(x => x.ConnectionModule);
const userModule = () => import('./_components/user/user.module').then(x => x.UserModule);
const routes: Routes = [
  
  { path: '', component: HomeComponent, canActivate: [AuthGuard] },
  { path: 'connection', loadChildren: connectionModule, canActivate: [AuthGuard] },
  { path: 'resetpassword', component: ResetPasswordComponent },
  { path: 'resetpassword/:token', component: ResetPasswordComponent },
  { path: 'account', loadChildren: accountModule },
  { path: 'user', loadChildren: userModule, canActivate: [AuthGuard] },

  { path: 'automation-request', component: AutomationRequestComponent },
  { path: 'information', component: InformationComponent },
  { path: 'validate/:reqId', component: UserValidateComponent },
  

  // otherwise redirect to home
  { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
